import {
  BRANDING,
  getBrandingConfig,
  getEnvBranding,
} from "@needl-ai/common/branding";

// Frozen fork of common's loadBranding: loads the VENDORED (pre-#29388) brand
// CSS so ICRA's look stays fixed regardless of future common theme changes.
// Branding config (logos/name/favicon) is still sourced from common.
export const loadFrozenBranding = async (): Promise<void> => {
  const branding = getEnvBranding();

  if (
    branding === BRANDING.ICRA ||
    branding === BRANDING.ICRA_RESEARCH_ASSIST
  ) {
    await import("./styles/icra.css");
  }

  const config = getBrandingConfig(branding);
  const updateBranding = () => {
    document.title = config.name;
    const favicon = document.getElementById(
      "favicon"
    ) as HTMLLinkElement | null;
    if (favicon) {
      favicon.href = config.favicon;
    }
  };

  if (document.readyState !== "loading") {
    updateBranding();
  } else {
    window.addEventListener("DOMContentLoaded", updateBranding, { once: true });
  }
};
